"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _types2 = require("@wix/ambassador-bookings-v2-bookings-settings/types");
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
const shouldOpenPreferencesModal = ({
  service,
  isDummy = false,
  isMultiServiceAppointmentEnabled,
  experiments,
  staffSelection,
  locationSelection
}) => {
  if (service.type !== _types.ServiceType.APPOINTMENT) {
    return false;
  }
  const hasMultiServiceAppointments = !isDummy && isMultiServiceAppointmentEnabled;
  const hasDynamicDuration = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithDynamicDuration)(service);
  const hasAddOns = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service, experiments);
  const hasStaffMemberBeforeSelection = hasStaffMemberBefore(service, staffSelection);
  const hasLocationBeforeSelection = hasLocationBefore(service, locationSelection);
  return hasMultiServiceAppointments || hasDynamicDuration || hasAddOns || hasStaffMemberBeforeSelection || hasLocationBeforeSelection;
};
exports.shouldOpenPreferencesModal = shouldOpenPreferencesModal;
const hasStaffMemberBefore = (service, staffSelection) => {
  const hasMultipleStaffMembers = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiStaff)(service);
  const hasCorrectTiming = (staffSelection == null ? void 0 : staffSelection.timing) === _types2.StaffSelectionTiming.BEFORE_SLOT_SELECTION;
  const customerCanChoose = (staffSelection == null ? void 0 : staffSelection.strategy) !== _types2.Strategy.CUSTOMER_CANNOT_CHOOSE;
  return hasMultipleStaffMembers && hasCorrectTiming && customerCanChoose;
};
const hasLocationBefore = (service, locationSelection) => {
  const hasMultipleLocations = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiBusinessLocations)(service);
  const hasCorrectTiming = (locationSelection == null ? void 0 : locationSelection.timing) === _types2.Timing.BEFORE_SLOT_SELECTION;
  return hasMultipleLocations && hasCorrectTiming;
};
//# sourceMappingURL=shouldOpenPreferencesModal.js.map